var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAwardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 13"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "award-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.632.75h12v12h-12z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#award-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.8 8.373v3.435a.25.25 0 0 1-.379.215L6.3 10.75l-2.122 1.273a.25.25 0 0 1-.378-.215V8.373a4 4 0 1 1 5 0m-4 .586v1.525l1.5-.9 1.5.9V8.959c-.463.188-.97.291-1.5.291s-1.037-.103-1.5-.29m1.5-.709a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
}))));
export { SvgAwardIcon as ReactComponent };
export default __webpack_public_path__ + "108b772466c51d85e88803eafc2bbf1f.svg";